class StickyAddToCart {
  constructor(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.variants = JSON.parse(document.getElementById(`StickyATC-variant-data-${this.sectionId}`).textContent);
    this.optionNames = JSON.parse(document.getElementById(`StickyATC-option-names-${this.sectionId}`).textContent);
    this.priceEl = document.getElementById(`StickyATC-price-${this.sectionId}`);
    this.qtyInput = document.getElementById(`StickyATC-qty-${this.sectionId}`);
    this.submitBtn = document.getElementById(`StickyATC-submit-${this.sectionId}`);
    this.optionWrappers = container.querySelectorAll('[data-option-position]');
    this.currentVariant = this.variants.find((v) => v.id === parseInt(this.submitBtn.dataset.variantId, 10));
    this.syncingFromMain = false;
    this.syncingQtyFromMain = false;

    this.initQuantity();
    this.bindEvents();
    this.observeMainAddToCart();
  }


  getMainQtyInput() {
    return (
      document.getElementById(`Quantity-${this.sectionId}`) ||
      document.querySelector(`#product-form-${this.sectionId} input[name="quantity"]`) ||
      document.querySelector('product-form input[name="quantity"], quantity-input input[name="quantity"]')
    );
  }

  initQuantity() {
    const mainQty = this.getMainQtyInput();
    if (!mainQty) return;

    ['min', 'max', 'step'].forEach((attr) => {
      if (mainQty.hasAttribute(attr)) this.qtyInput.setAttribute(attr, mainQty.getAttribute(attr));
    });
    if (mainQty.value) this.qtyInput.value = mainQty.value;
  }


  bindEvents() {
    this.container.querySelectorAll('.sticky-atc__pill-input, .sticky-atc__select').forEach((input) => {
      input.addEventListener('change', this.onStickyOptionChange.bind(this));
    });

    this.qtyInput.addEventListener('change', this.onStickyQtyChange.bind(this));

    this.container.querySelector('[data-qty-minus]').addEventListener('click', () => {
      const min = parseInt(this.qtyInput.min, 10) || 1;
      this.qtyInput.value = Math.max(min, parseInt(this.qtyInput.value, 10) - 1);
      this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    this.container.querySelector('[data-qty-plus]').addEventListener('click', () => {
      this.qtyInput.value = parseInt(this.qtyInput.value, 10) + 1;
      this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    this.submitBtn.addEventListener('click', this.onSubmit.bind(this));

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (target.closest('.sticky-atc')) return;

      const variantScope = document.getElementById(`variant-selects-${this.sectionId}`);
      if (variantScope && variantScope.contains(target)) {
        this.syncFromMain();
        return;
      }

      const mainQty = this.getMainQtyInput();
      if (mainQty && target === mainQty) {
        this.syncQtyFromMain();
      }
    });
  }


  onStickyQtyChange() {
    if (this.syncingQtyFromMain) return;
    const val = parseInt(this.qtyInput.value, 10);
    if (isNaN(val) || val < 1) {
      this.qtyInput.value = 1;
      return;
    }

    const mainQty = this.getMainQtyInput();
    if (mainQty && mainQty.value !== this.qtyInput.value) {
      mainQty.value = this.qtyInput.value;
      mainQty.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  syncQtyFromMain() {
    const mainQty = this.getMainQtyInput();
    if (!mainQty) return;
    if (this.qtyInput.value === mainQty.value) return;

    this.syncingQtyFromMain = true;
    this.qtyInput.value = mainQty.value;
    this.syncingQtyFromMain = false;
  }


  getMainSelectedOptions() {
    const scope = document.getElementById(`variant-selects-${this.sectionId}`);
    if (!scope) return [];

    return this.optionNames.map((name) => {
      const els = Array.from(scope.querySelectorAll(`[data-option-name="${CSS.escape(name)}"]`));
      if (!els.length) return null;

      if (els[0].tagName === 'OPTION') {
        const select = els[0].closest('select');
        return select ? select.value : null;
      }

      const checked = els.find((el) => el.checked);
      return checked ? checked.value : null;
    });
  }

  getStickySelectedOptions() {
    const options = [];
    this.optionWrappers.forEach((wrapper) => {
      const position = parseInt(wrapper.dataset.optionPosition, 10);
      const checkedPill = wrapper.querySelector('.sticky-atc__pill-input:checked');
      const select = wrapper.querySelector('.sticky-atc__select');
      const value = checkedPill ? checkedPill.value : select ? select.value : null;
      if (value) options[position - 1] = value;
    });
    return options;
  }

  findMatchingVariant(options) {
    return this.variants.find((variant) => variant.options.every((opt, idx) => opt === options[idx]));
  }


  onStickyOptionChange() {
    if (this.syncingFromMain) return;
    const options = this.getStickySelectedOptions();
    const matched = this.findMatchingVariant(options);
    if (!matched) return;

    this.currentVariant = matched;
    this.updateUI(matched);

    options.forEach((value, idx) => this.setMainOption(this.optionNames[idx], value));
  }

  setMainOption(optionName, value) {
    const scope = document.getElementById(`variant-selects-${this.sectionId}`);
    if (!scope) return;

    const els = Array.from(scope.querySelectorAll(`[data-option-name="${CSS.escape(optionName)}"]`));
    if (!els.length) return;

    if (els[0].tagName === 'OPTION') {
      const select = els[0].closest('select');
      if (select && select.value !== value) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      const target = els.find((el) => el.value === value);
      if (target && !target.checked) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }


  syncFromMain() {
    const options = this.getMainSelectedOptions();
    const matched = this.findMatchingVariant(options);
    if (!matched) return;

    this.currentVariant = matched;
    this.updateUI(matched);

    this.syncingFromMain = true;
    this.setStickyInputs(options);
    this.syncingFromMain = false;
  }

  setStickyInputs(options) {
    this.optionWrappers.forEach((wrapper) => {
      const position = parseInt(wrapper.dataset.optionPosition, 10);
      const value = options[position - 1];
      if (!value) return;

      const pill = wrapper.querySelector(`.sticky-atc__pill-input[value="${CSS.escape(value)}"]`);
      if (pill && !pill.checked) pill.checked = true;

      const select = wrapper.querySelector('.sticky-atc__select');
      if (select && select.value !== value) select.value = value;
    });
  }


  updateUI(variant) {
    this.submitBtn.dataset.variantId = variant.id;

    this.priceEl.innerHTML =
      variant.compare_at_price && variant.compare_at_price > variant.price
        ? `<span class="sticky-atc__price-compare">${this.formatMoney(variant.compare_at_price)}</span><span class="sticky-atc__price-current sticky-atc__price-sale">${this.formatMoney(variant.price)}</span>`
        : `<span class="sticky-atc__price-current">${this.formatMoney(variant.price)}</span>`;

    const submitText = this.submitBtn.querySelector('.sticky-atc__submit-text');
    this.submitBtn.disabled = !variant.available;
    submitText.textContent = variant.available
      ? window.stickyAtcStrings.addToCart
      : window.stickyAtcStrings.soldOut;
  }

  formatMoney(cents) {
  if (window.Shopify && Shopify.formatMoney) {
    return `${Shopify.formatMoney(cents, window.stickyAtcMoneyFormat)} ${window.stickyAtcCurrencyCode}`;
  }
  return `${(cents / 100).toFixed(2)} ${window.stickyAtcCurrencyCode || ''}`.trim();
}


  onSubmit() {
    if (this.submitBtn.disabled) return;
    const variantId = this.submitBtn.dataset.variantId;
    const quantity = parseInt(this.qtyInput.value, 10) || 1;

    this.submitBtn.disabled = true;
    this.submitBtn.classList.add('loading');

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity }],
        sections: this.getCartSections(),
        sections_url: window.location.pathname,
      }),
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || 'Add to cart error');
        this.renderCart(response);
      })
      .catch((error) => console.error('Sticky ATC error:', error))
      .finally(() => {
        this.submitBtn.disabled = false;
        this.submitBtn.classList.remove('loading');
      });
  }

  getCartSections() {
    const cartDrawer = document.querySelector('cart-drawer, cart-notification');
    return cartDrawer && cartDrawer.getSectionsToRender ? cartDrawer.getSectionsToRender().map((s) => s.id) : [];
  }

  renderCart(response) {
    const cartDrawer = document.querySelector('cart-drawer');
    const cartNotification = document.querySelector('cart-notification');

    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(response);
      cartDrawer.classList.remove('is-empty');
      if (typeof cartDrawer.open === 'function') cartDrawer.open();
    } else if (cartNotification && typeof cartNotification.renderContents === 'function') {
      cartNotification.renderContents(response);
    } else {
      window.location.href = `${window.Shopify.routes.root}cart`;
      return;
    }

    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && response.sections && response.sections['cart-icon-bubble']) {
      const doc = new DOMParser().parseFromString(response.sections['cart-icon-bubble'], 'text/html');
      const newBubble = doc.querySelector('.shopify-section');
      if (newBubble) cartIconBubble.innerHTML = newBubble.innerHTML;
    }
  }


  observeMainAddToCart() {
    const mainSubmit =
      document.querySelector(`#product-form-${this.sectionId} button[type="submit"]`) ||
      document.querySelector('product-form button[type="submit"]');

    if (!mainSubmit) {
      this.container.classList.add('sticky-atc--visible');
      return;
    }

    new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.container.classList.toggle('sticky-atc--visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    ).observe(mainSubmit);
  }
}

document.querySelectorAll('.sticky-atc').forEach((el) => new StickyAddToCart(el));